import './card-form.scss';

export default () => {
	$( '.gfield--type-text .ginput_container > *, .gfield--type-email .ginput_container > *, .gfield--type-textarea .ginput_container > *' ).on( 'focus change', function (  ) {
		$( this ).closest( '.gfield' ).addClass( 'is-active' );
		if ( $( this ).val().length ) {
			$( this ).closest( '.gfield' ).addClass( 'is-filled' );
		} else {
			$( this ).closest( '.gfield' ).removeClass( 'is-filled' );
		}
	} );

	$( document ).click( function ( e ) {
		if ( !$( e.target ).closest( '.card-form' ).length ) {
			$( '.gfield' ).not( '.is-filled' ).removeClass( 'is-active' );
		}
	} );
};
